import React from 'react';
import RenderString from '../utils/Utils';

class Dropdown extends React.Component {

    constructor(state) {
        super(state)

        this.state = {selectedReferal: "0"}
    }

    onChange = (e) => {
        this.props.onChange(e);   
        if (e.target.name === 'referalSource') {
            this.setState({ selectedReferal: e.target.value })
        }
     
    }

    render() {
        return (
            <React.Fragment>
                <div className="form-group">
                    <label htmlFor="referalSource">How did you find out about this program?*</label>
                    <select name="referalSource" id="referalSource" className="form-control custom-select" onChange={this.onChange}>
                        <option value="0" defaultValue>Please select an option</option>
                        <option value="1">Another creator&apos;s content</option>
                        <option value="2">Another creator&apos;s social media</option>
                        <option value="3">Search engine</option>
                        <option value="4">Other</option>
                    </select>
                    <div className="invalid-feedback">
                        <RenderString string={this.props.validationMsg} />
                    </div>
                    <br />
                    {this.state.selectedReferal === "4" &&
                        <React.Fragment>
                            <br />
                            <div className="form-group">
                                <input type="text" className="form-control" id="referalSourceOtherText" name="referalSourceOtherText" placeholder="Other..."
                                onChange={this.onChange} />
                            <div className="invalid-feedback">
                                <RenderString string={this.props.validationMsg} />
                                </div>
                            </div>
                        </React.Fragment>

                    }
                </div>

            </React.Fragment>
        );
    };
}

export default Dropdown;